module.exports = __webpack_public_path__ + "static/media/aoe-4-with-black.8b2be9d7.svg";


//////////////////
// WEBPACK FOOTER
// ./src/lib/monsters/aoe-4-with-black.svg
// module id = 67
// module chunks = 0